/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportGraaspEuIlsResult } from '../../models/import-graasp-eu-ils-result';

export interface GraaspEuIlsImportControllerImportGraaspEuIls$Params {
  folderId: string;
  ilsName: string;
  checkOnly: boolean;
}

export function graaspEuIlsImportControllerImportGraaspEuIls(http: HttpClient, rootUrl: string, params: GraaspEuIlsImportControllerImportGraaspEuIls$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportGraaspEuIlsResult>> {
  const rb = new RequestBuilder(rootUrl, graaspEuIlsImportControllerImportGraaspEuIls.PATH, 'post');
  if (params) {
    rb.path('folderId', params.folderId, {});
    rb.path('ilsName', params.ilsName, {});
    rb.path('checkOnly', params.checkOnly, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportGraaspEuIlsResult>;
    })
  );
}

graaspEuIlsImportControllerImportGraaspEuIls.PATH = '/graasp-eu-ils-import/{folderId}/{ilsName}/{checkOnly}';
